import templateUrl from './days-of-operation.html';

export const daysOfOperationComponent = {
	templateUrl,

	bindings: {
		details: '<'
	},

	controller: class DaysOfOperationComponent {
		_getClass(day) {
			return this.details[day] === true ? 'activeDay' : 'inActiveDay';
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/common/components/days-of-operation/days-of-operation.component.js